<template>
	<div>
		<div style="margin-bottom:10px;">
	        <el-input v-model="bookName" placeholder="请输入图书名称" style="width: 250px; margin-right: 10px" clearable></el-input>
	        <el-select v-model="isShow" slot="prepend" placeholder="请选择是否显示" style="width:150px" clearable >
	            <el-option label="全部" value="-1"></el-option>
	            <el-option label="不显示" value="0"></el-option>
	            <el-option label="显示" value="1"></el-option>
	        </el-select>
	        <el-select v-model="isTop" slot="prepend" placeholder="请选择是否置顶" style="width:150px" clearable >
	            <el-option label="全部" value="-1"></el-option>
	            <el-option label="不置顶" value="0"></el-option>
	            <el-option label="置顶" value="1"></el-option>
	        </el-select>
	        <el-date-picker
	            v-model="selectDate"
	            align="right"
	            type="date"
	            placeholder="请选择日期"
	            value-format="yyyy-MM-dd"
	            style="margin-right: 10px;">
	        </el-date-picker>
	        <el-button slot="append" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
	    </div>
		<el-table
			v-if="permissionShow"
			v-loading="loading"
			element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
			:data="tableData"
			border
			style="width: 100%"
			height="500">
			<el-table-column prop="lr_id" label="序号" sortable align="center"  width="90"></el-table-column>
			<el-table-column prop="lr_sort" label="排序" sortable align="center" width="160"></el-table-column>
			<el-table-column prop="lr_isshow" label="是否显示" sortable align="center" min-width="160">
				<template slot-scope="scope">
					<el-switch
						on-text="是"
						off-text="否"
						active-color="#13ce66"
						inactive-color="#dcdfe6" 
						active-value="100"
						inactive-value="0"
						:disabled="!permissionSetShow"
						v-model="scope.row.lr_isshow"
						@click.native="changeShow(scope.$index,scope.row)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="lr_istop" label="是否置顶首页" sortable align="center" min-width="160">
				<template slot-scope="scope">
                <el-switch
                    on-text="是"
                    off-text="否"
                    active-color="#13ce66" 
                    inactive-color="#dcdfe6" 
                    active-value="100"
                    inactive-value="0"
                    :disabled="!permissionSetTop"
                    v-model="scope.row.lr_istop" 
                    @click.native="changeTop(scope.$index,scope.row)">
                </el-switch>
            </template>
			</el-table-column>
			<el-table-column prop="lr_createtime" label="创建时间" sortable align="center" min-width="160"></el-table-column>
			<el-table-column prop="lr_name" label="标题" sortable align="center" min-width="180"></el-table-column>
			<el-table-column prop="lr_pic" label="封面图片地址" sortable align="center" min-width="180"></el-table-column>
			<el-table-column
				fixed="right"
				label="操作"
				align="center"
				min-width="180"
				v-if="permissionDetail || permissionEdit">
				<template slot-scope="scope">
					<el-button v-if="permissionDetail" @click="handleDetail(scope.row)" type="text" size="small">查看</el-button>
					<el-button v-if="permissionEdit" @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<div id="pagination">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="total"
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>

		<!-- 编辑模态框 -->
		<el-dialog 
			:visible.sync="EditDialogTableVisible"
			title="修改角色" 
			top="8%"
			width="40%"
			@closed="cancleEditForm('EditForm')"
			:close-on-click-modal="false">
			<el-form ref="EditForm" :model="EditForm" label-width="140px" :rules="EditRules">
				<el-form-item label="角色名称" prop="role_name">
					<el-input v-model="EditForm.role_name"></el-input>
				</el-form-item>
				<el-form-item label="角色说明" prop="role_remark">
					<el-input type="textarea" v-model="EditForm.role_remark" rows="6"></el-input>
				</el-form-item>
				<el-form-item class="text-align-right">
					<el-button type="primary" @click="submitEditForm('EditForm')">提交</el-button>
					<el-button @click="cancleEditForm('EditForm')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'
// 时间过滤器
import {formatDate} from '@/filter/date.js'

export default {
	name: 'booksRecommend',
	data() {
		return {
			/* 
			 * tableData: 表格数据
			 * loading: 加载状态（默认为true）
			 * total: 总条数（table数据总长度）
			 * start: 表格分页（默认第一页）
			 * limit: 每页显示条数
			 * bookName: 搜索（图书名称）
			 * isShow: 搜索是否显示
			 * isTop: 搜索是否置顶
			 * selectDate: 搜索选择日期
			 */
			tableData : [],
			loading : true,
			total: 0,
			start : 0,
			limit : 10,
			bookName : '' ,
			isShow : '' ,
			isTop : '' ,
			selectDate : '' ,
            searchData: {
                name1: '',
                id1: '',
                id2: '',
                date_start1: ''
            },

			/* 编辑部分 */
			EditDialogTableVisible : false, //默认隐藏
			EditForm : {
				role_name: '',
				role_remark: '',
			},
			EditRules : {
				role_name : [{required: true, message : '请输入角色名称', trigger: 'blur'}],
			},

			permissionShow: false, // 默认为false,根据权限是否显示
			permissionEdit: false, // 默认为false,根据权限是否修改
			permissionDetail: false, // 默认为false,根据权限是否新建
			permissionSetShow: false, // 默认为false,根据权限是否可以权限管理
			permissionSetTop: false, // 默认为false,根据权限是否查看
		}
	},
	methods : {
		/* 获取权限 */
		getSubPermission() {
			this.$http.get(
				`${api.dev}/p/permission/getSub`,
				{
					params:{
						access_token:getToken(),
						p_id: this.$route.params.id
					}
				}
			).then(res => {
				if(res.body.code == 200) {
					res.body.content.forEach(item => {
						
						if(item.p_name.indexOf('显示') > -1) {
							this.permissionShow = true;
						}else if(item.p_name.indexOf('修改') > -1) {
							this.permissionEdit = true;
						}else if(item.p_name.indexOf('查看') > -1) {
							this.permissionDetail = true;
						}else if(item.p_name.indexOf('设置新书推荐显示') > -1) {
							console.log('显示/不显示');
							this.permissionSetShow = true;
						}else if(item.p_name.indexOf('置顶/不置顶') > -1) {
							this.permissionSetTop = true;
						}
					})
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						window.location.href = '/stwhy';
					},2000)
				}
			})
		},
        /* 搜索 */
        handleSearch(){
            this.searchData = {
                name1: this.bookName,
                id1: this.isShow,
                id2: this.isTop,
                date_start1: this.selectDate,
            };
            this.getInfo();
        },
		/* 表格数据加载 */
		getInfo(){
			var formdata = new FormData();
			formdata.append('access_token',getToken());
			formdata.append('start',this.start);
			formdata.append('limit',this.limit);
			formdata.append('name1',this.searchData.name1);
			formdata.append('id1',this.searchData.id1);
			formdata.append('id2',this.searchData.id2);
			formdata.append('date_start1',this.searchData.date_start1);			
			this.$http.post(
				`${api.dev}/p/main/booksRecommend/show`,
				formdata,
				{emulateJSON : true}
			).then(res => {
				if(res.body.code == 200) {
					res.body.content.records.forEach( item => {
						if(item.lr_istop == true) {
							item.lr_istop = '100'
						}else {
							item.lr_istop = '0'
						}

						if(item.lr_isshow == true) {
							item.lr_isshow = '100'
						}else {
							item.lr_isshow = '0'
						}
						// 过滤时间
						item.lr_createtime = formatDate(new Date(item.inf_createtime),'yyyy-MM-dd')
					})
					this.tableData = res.body.content.records;
					this.total = res.body.content.total;
					this.loading = false;
				}else if (res.body.code == 500) {
					this.$message({
						message : res.body.msg,
						type : 'error'
					})
					//removeToken();
					setTimeout(function () {
						//window.location.href = '/stwhy';
					},2000)
				}
			})
		},
		/* 搜素加载 */
		handleSearch() {
			this.loading = true;
			this.getInfo();
		},
		/* 控制是否显示按钮 */
		changeShow(index,row) {
			this.$http.post(
				`${api.dev}/p/main/booksRecommend/setShow`,
				{
					access_token: getToken(),
					lr_id : row.lr_id
				},
				{emulateJSON: true}
			).then(res => {
				if(res.body.code == 200) {
					this.$message({
						message: res.body.msg,
						type: 'success'
					});
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}
			})
		},
		/* 控制是否置顶按钮 */
		changeTop(index,row) {
			this.$http.post(
				`${api.dev}/p/main/booksRecommend/setTop`,
				{
					access_token: getToken(),
					lr_id: row.lr_id
				},
				{emulateJSON: true}
			).then(res => {
				if(res.body.code == 200) {
					this.$message({
						message : res.body.msg,
						type : 'success'
					})
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					})
				}
			})
		},
		/* 编辑提交 */
		submitEditForm(formName) {
		  this.$refs[formName].validate((valid) => {
			  if(valid) {
					// 开启加载器
					const loading = this.$loading({
						lock: true,
						text: '正在保存中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var formdata = new FormData();
					formdata.append('access_token',getToken());
					formdata.append('role_name',this.EditForm.role_name);
					formdata.append('role_remark',this.EditForm.role_remark);
					formdata.append('role_id',this.EditForm.role_id);

					this.$http.post(
						`${api.dev}/p/main/role/update`,
						formdata,
						{emulateJSON:true}
					).then(res => {
						loading.close();
						if(res.body.code == 200) {
							this.EditDialogTableVisible = false;
							this.$refs[formName].clearValidate(); // 清除表单验证规则
							this.$message({
								message: res.body.msg,
								type: 'success'
							});
							//this.loading = true;
							this.getInfo();
						}else if (res.body.code == 500) {
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
						}
					})
			  }else {
				  console.log('error submit');
				  return false;
			  }
		  })
		},
		/* 取消编辑 */
		cancleEditForm(formName) {
			this.EditDialogTableVisible = false;
			this.$refs[formName].clearValidate(); // 清除表单验证规则
		},
		/* 分页 */
		handleCurrentChange(val) {
			this.loading = true;
			this.start = 10 * (val - 1);
			this.getInfo();
		}
	},
	created() {
		this.getSubPermission();
		this.getInfo();
	}
}
</script>


<style lang="stylus" scoped>
#pagination
	margin-top 10px

</style>

<style scoped>
.el-select.el-select--medium {
    margin: 0 10px 0 0;
}
</style>
